import makeValidation from "@/mixins/makeValidation";
import { VuexSnackbar } from "@/mixins/makeVuexSnackbar";
/**
 * Permet d'exposer les methodes de sauvegarde et de validation. Intégre également l'accès au VuexSnackbar
 * @param {*} options  les options de makeValidation
 * @returns
 */
export default function makeRemoteWorker(options) {
    const workingVars = (options || {}).workings || ["working"];
    return {
        mixins: [
            makeValidation(options),
            VuexSnackbar
        ],
        data() {
            const out = {};
            for (const key of workingVars) {
                out[key] = false;
            }
            return out;
        },
        methods: {
            /**
             * Realise un travail générique
             * @param {*} param0
             */
            doWork({ forms = [], work, working = "working", callback, errorText, successText, errorSubtext = "Veuillez vérifier votre saisie.", specific }) {
                if (this.validate(forms)) {
                    this[working] = true;
                    work.call(this)
                        .then(response => {
                            const msg = { text: successText, color: "success" };
                            if (specific && callback) {
                                return callback.call(this, response, msg);
                            }
                            this.snackbar(msg);
                            if (callback) {
                                return callback.call(this, response);
                            }
                            return null;
                        }, error => {
                            this.remoteError(error, forms);
                            let subtext= errorSubtext;
                            if(!subtext.endsWith("."))
                                subtext+=".";
                            subtext+=" Les erreurs sont indiquées en rouge.";
                            const msg = { text: errorText, subtext };
                            this.snackbar(msg, error);
                        })
                        .finally(() => {
                            this[working] = false;
                        });
                }
            },
        }
    }
}
